import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Game from "./Game";
import reportWebVitals from "./reportWebVitals";
import config from "../package.json";

import { FullScreen, useFullScreenHandle } from "react-full-screen";

const FullScreenHandler = () => {
  const handle = useFullScreenHandle();
  const [showGame, setShowGame] = useState(false);
  const handleFullscreenChange = (state) => {
    // console.log(state);
    setShowGame(state);
  };
  return (
    <>
      <button onClick={handle.enter}>Enter fullscreen</button>
      <FullScreen handle={handle} onChange={handleFullscreenChange}>
        <Game />
        {/* <Game /> */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            fontSize: 10,
            color: "gray",
          }}
        >
          v{config.version}
        </div>
      </FullScreen>
    </>
  );
};
ReactDOM.render(
  <React.StrictMode>
    <Game />
  </React.StrictMode>,
  document.getElementById("content")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
